import React from 'react';
import BaseComponent from './BaseComponent';
import ClientSelector from './ClientSelector.js';
//import UserSelector from './UserSelector.js';
import $ from 'jquery';
//import {setUsers} from '../actionCreators';

import { ScheduleComponent, Day, Week, Month, Inject, ViewsDirective, ViewDirective } from '@syncfusion/ej2-react-schedule';
import { L10n, setCulture, loadCldr } from '@syncfusion/ej2-base';
import { DateTimePickerComponent } from '@syncfusion/ej2-react-calendars';
import { DropDownListComponent } from '@syncfusion/ej2-react-dropdowns';
import locale from './scheduler-localized.json';
import numberingSystems from './numberingSystems.json';
import gregorian from './ca-gregorian.json';
import numbers from './numbers.json';
import timeZoneNames from './timeZoneNames.json';

L10n.load(locale);
loadCldr(numberingSystems, gregorian, numbers, timeZoneNames);
setCulture('es');

class Scheduler extends BaseComponent {

    loadOnConstructor(){
		this.clientSelectedCallback = this.clientSelectedCallback.bind(this);
		this.userSelectedCallback = this.userSelectedCallback.bind(this);
		this.editorTemplate = this.editorTemplate.bind(this);
		this.addClient = this.addClient.bind(this);
		this.addUser = this.addUser.bind(this);
		this.apiNewCallback = this.apiNewCallback.bind(this);
		this.apiDeleteCallback = this.apiDeleteCallback.bind(this);
		this.deleteAppointment = this.deleteAppointment.bind(this);
		this.getSchedules = this.getSchedules.bind(this);
		this.getAppointmentsCallback = this.getAppointmentsCallback.bind(this);
		this.transformSchedulesToAppointments = this.transformSchedulesToAppointments.bind(this);
		this.modifyAppointmentCallback = this.modifyAppointmentCallback.bind(this);
		this.initializeRefs = this.initializeRefs.bind(this);
		this.handleInputChanges = this.handleInputChanges.bind(this);
		this.removeEvent = this.removeEvent.bind(this);
		this.changeEvent = this.changeEvent.bind(this);
		this.createEvent = this.createEvent.bind(this);
		this.deleteFromSerie = this.deleteFromSerie.bind(this);
		this.changeFromSerie = this.changeFromSerie.bind(this);
		this.stringDateToExceptionDate = this.stringDateToExceptionDate.bind(this);
		this.createNewEvent = this.createNewEvent.bind(this);
		this.refresh = this.refresh.bind(this);

		this.state = {appointments: [], reload: false};

		this.initializeRefs();

		this.getSchedules();
    }

	refresh(){
		this.setState(prevState => {
			return {
				...prevState,
				reload: true
			}
		}, () => this.setState({reload: false}))
	}

	initializeRefs(){
		this.clientSel = React.createRef();
		this.clientInput = React.createRef();
		this.userInput = React.createRef();

		this.clientInputValue = {};
		this.clientFromAppointment = false;
		this.userInputValue = {};
		this.deletedClient = false;

		this.statusSelected = false;
		this.frequency = false;
		this.repeatUntilDate = false;
		this.repeatTimesValue = false;
		this.repeatDate = React.createRef();
		this.repeatTimes = React.createRef();
		this.repeatOption1 = React.createRef();
		this.repeatOption2 = React.createRef();
		this.radioRepeatUntil = React.createRef();
		this.radioRepeatTimes = React.createRef();

	}

	getSchedules(){
		const api = this.getApi();
		const apiParams = [
			{
				name: "byToken",
				value: 1
			},
			{
				name: "populate_client",
				value: 1
			}
		];

		api.getSchedules(apiParams,this.getAppointmentsCallback);
	}

	getAppointmentsCallback(response){
		if(response.status === 'OK'){
			this.setState(prevState => {
			return {
				...prevState,
				appointments: this.transformSchedulesToAppointments(response.schedules)
			}
			},this.refresh);
		}else{
			alert("Se ha perdido la sesion");
		}
	}

	transformSchedulesToAppointments(schedules, singleObject){

		if(singleObject === true){
			schedules = [schedules];
		}

		const today = new Date();
		const hoursFromTimezoneOffset = today.getTimezoneOffset() / 60;

		let schs = schedules.map(sch => {

			let startTime = new Date(sch.start_date);
			if(sch.start_date.indexOf("T") > -1) startTime.setHours(startTime.getHours()+hoursFromTimezoneOffset);

			let endTime = new Date(sch.end_date);
			if(sch.end_date.indexOf("T") > -1) endTime.setHours(endTime.getHours()+hoursFromTimezoneOffset);

			let repeatUntil = sch.repeat_until!== undefined? new Date(sch.repeat_until):undefined;
			if(typeof repeatUntil !== undefined && 
				sch.repeat_until!== undefined && sch.repeat_until.indexOf("T") > -1){
				repeatUntil.setHours(repeatUntil.getHours()+hoursFromTimezoneOffset);
			}

			let RecurrenceRule = sch.frequency !== 'NONE' && sch.frequency !== undefined?"FREQ="+sch.frequency+";INTERVAL=1;":"";
			RecurrenceRule += sch.repeat_until?
				"UNTIL="+sch.repeat_until.replace(/[\-\s:\.]/g, '').substring(0,15)+"Z;":"";
			RecurrenceRule += sch.repeat_times?"COUNT="+sch.repeat_times:"";

			return {
				Subject: sch.Subject?sch.Subject:sch.title,
				StartTime: sch.StartTime?sch.StartTime:startTime,
				EndTime: sch.EndTime?sch.EndTime:endTime,
				Description: sch.Description?sch.Description:sch.description,
				id: sch.id?sch.id:sch._id,
				status: sch.status,
				client: sch.client?sch.client:null,
				completeClient: sch.client?sch.client:null,
				frequency: sch.frequency?sch.frequency:'NONE',
				clientName: sch.client?sch.client.name+' '+sch.client.lastname:'',
				assigned_user: typeof sch.assigned_user === 'string'?sch.assigned_user:sch.assigned_user._id,
				RecurrenceRule: RecurrenceRule,
				RecurrenceException: /*'20220126T080000Z',*/ sch.exceptions?sch.exceptions:undefined,
				exceptions: sch.exceptions?sch.exceptions:undefined,
				repeatTimes: sch.repeat_times,
				repeatUntil: sch.repeat_until?repeatUntil:undefined
			}
		});
		
		if(singleObject){
			schs = schs[0];
		}

		return schs;
    }

    transformAppointmentToSchedule(originalAppointment){
		const today = new Date();
		const hoursFromTimezoneOffset = (today.getTimezoneOffset()*-1) / 60;
		

		let appointment = {...originalAppointment};
		appointment.StartTime = new Date(originalAppointment.StartTime.getTime());
		appointment.EndTime = new Date(originalAppointment.EndTime.getTime());

		appointment.StartTime.setHours(appointment.StartTime.getHours()+hoursFromTimezoneOffset);
		appointment.EndTime.setHours(appointment.EndTime.getHours()+hoursFromTimezoneOffset);

		const startDateString =
			appointment.StartTime.getUTCFullYear() + "-" +
			("0" + (appointment.StartTime.getUTCMonth()+1)).slice(-2) + "-" +
			("0" + appointment.StartTime.getUTCDate()).slice(-2) + " " +
			("0" + appointment.StartTime.getUTCHours()).slice(-2) + ":" +
			("0" + appointment.StartTime.getUTCMinutes()).slice(-2) + ":" +
			("0" + appointment.StartTime.getUTCSeconds()).slice(-2);

		const endDateString =
			appointment.EndTime.getUTCFullYear() + "-" +
			("0" + (appointment.EndTime.getUTCMonth()+1)).slice(-2) + "-" +
			("0" + appointment.EndTime.getUTCDate()).slice(-2) + " " +
			("0" + appointment.EndTime.getUTCHours()).slice(-2) + ":" +
			("0" + appointment.EndTime.getUTCMinutes()).slice(-2) + ":" +
			("0" + appointment.EndTime.getUTCSeconds()).slice(-2);


		let client = appointment.client;
		if(!appointment.client || appointment.client === 'undefined' || appointment.client === undefined){
			client = null;
		}

		return  {
			title: appointment.Subject,
			start_date: startDateString,
			end_date: endDateString,
			description: appointment.Description,
			_id: appointment.id,
			client: client,
			status: appointment.status,
			assigned_user: appointment.assigned_user
		}
    }

    clientSelectedCallback(clientSelected){
    	this.clientInputValue = clientSelected!== null?clientSelected.clients[0]:null;
    	this.deletedClient = this.clientInputValue === null?true:false;
    	this.clientInput.current.value = clientSelected!== null && this.clientInputValue?this.clientInputValue.name+' '+this.clientInputValue.lastname:'';
    }

    userSelectedCallback(){
	//TODO: Hay que dejar el usuario igual que el cliente, sin redux.
    	//this.clientInputValue = clientSelected.clients[0];
    	//this.clientInput.current.value = this.clientInputValue.name+' '+this.clientInputValue.lastname; 
    }

    addClient(){
    	this.clientSel.current.setCurrentSelection(this.clientFromAppointment);
	$("#client-selector-component").modal('toggle');
    }

    addUser(){
/*
	this.props.setUsers({
	    title: 'Seleccione usuario',
	    buttons: [
	    {shown: 'Aplicar', close: true, callback: this.userSelectedCallback, behaviour: 'main'},
	    {shown: 'Cerrar', close: true}
	    ]
	});

	$("#user-selector-component").modal('toggle');
*/
    }

    editorTemplate(props) {

    	const statusFieldsSource = { text: 'text', value: 'value' };

    	const statusTypeSource = [
		{text: "Planificado", value: 1},
		{text: "Finalizado", value: 2},
		{text: "Cancelado", value: 3}
    	    ];

		this.clientFromAppointment = props.client;

		const frequencyFields = { value: 'value', text: 'text' };
		const frequencyTypes = [
			{ text: 'Nunca', value: 'NONE' },
			{ text: 'Diario', value: 'DAILY' },
			{ text: 'Semanal', value: 'WEEKLY' },
			{ text: 'Mensual', value: 'MONTHLY' }

		  ];

		  let statusSelected = 0;
		  statusTypeSource.forEach((elem, index) => {
			if(elem.value === props.status ){
				statusSelected = index;
				this.statusSelected = elem.value;
			}
		  });

		  let frequencySelected = 0;
		  frequencyTypes.forEach((elem, index) => {
			if(elem.value === props.frequency ) frequencySelected = index;
		  });

		  const repeatVisibility = props.frequency === 'NONE' || props.frequency === undefined?'none':'';


	return (props !== undefined ? <table className="custom-event-editor" style={{ width: '100%', cellpadding: '5' }}><tbody>
		<tr><td className="e-textlabel">Título</td><td colSpan={4}>
		<input id="Summary" className="e-field e-input" type="text" name="Subject" style={{ width: '100%' }}/>
		</td></tr>
		<tr>
			<td className="e-textlabel">Cliente</td>
			<td><input ref={this.clientInput} id="clientName" type="text" className="e-field e-input" name="clientName" readOnly />
			<input id="client" type="hidden" name="client"/> 
			{/*Se mete aqui assigned_user mientras siga comentada la fila del usuario, para que input no sea hijo de tbody*/}
			<input id="assigned_user" type="hidden" name="assigned_user"/> </td>
			<td><button className="btn btn-primary" onClick={this.addClient} >{this.state.selectedClient?"Cambiar cliente":"Agregar cliente"}</button></td>
		</tr>
		<tr><td className="e-textlabel">Estado</td><td colSpan={4}>
		<DropDownListComponent id="status" placeholder='Elija estado' data-name="status"
			change={this.handleInputChanges} 
			fields={statusFieldsSource} 
			dataSource={statusTypeSource} 
			index={statusSelected} />
		</td></tr>
		<tr><td className="e-textlabel">Desde</td><td colSpan={4}>
		<DateTimePickerComponent step="15" format='dd/MM/yy hh:mm a' id="StartTime" data-name="StartTime" value={new Date(props.startTime || props.StartTime)} className="e-field"></DateTimePickerComponent>
		</td></tr>
		<tr><td className="e-textlabel">Hasta</td><td colSpan={4}>
		<DateTimePickerComponent step="15" format='dd/MM/yy hh:mm a' id="EndTime" data-name="EndTime" value={new Date(props.endTime || props.EndTime)} className="e-field"></DateTimePickerComponent>
		</td></tr>
		<tr><td className="e-textlabel">Se repite</td><td colSpan={4}>
			<DropDownListComponent id="frequency" placeholder='Elija frecuencia' 
				data-name="frequency" index={frequencySelected} change={this.handleInputChanges} 
				fields={frequencyFields} dataSource={frequencyTypes} 
			/>
		</td></tr>
		<tr ref={this.repeatOption1} style={{display: repeatVisibility}}>
			<td>
				<input ref={this.radioRepeatUntil} type="radio" value="Until" name="repeat_type" id="repeat_until" 
					onClick={this.handleInputChanges} checked={props.repeatUntil?true:undefined} 
				/>
				<label htmlFor="repeat_until" style={{marginLeft: '5px'}}>Hasta</label>
			</td>
			<td colSpan={4}>
				<DateTimePickerComponent change={this.handleInputChanges}
					ref={this.repeatDate} step="15" format='dd/MM/yy hh:mm a' id="repeat_until_date"
					data-name="RepeatUntilDate" value={new Date(props.repeatUntil || props.RepeatUntil)}>
				</DateTimePickerComponent>
			</td>
		</tr>
		<tr ref={this.repeatOption2} style={{display: repeatVisibility}}>
			<td>
				<input checked={props.repeatTimes?true:undefined} ref={this.radioRepeatTimes} type="radio" value="During" name="repeat_type" id="repeat_times" 
					onClick={this.handleInputChanges} 
				/>
				<label htmlFor="repeat_times" style={{marginLeft: '5px'}}>N&uacute;mero</label>
			</td>
			<td colSpan={3}>
				<input ref={this.repeatTimes} type="number" name="times" style={{width: '40px'}} 
					onChange={this.handleInputChanges} defaultValue={props.repeatTimes?props.repeatTimes:''} 
				/>
				
				<label style={{marginLeft: '5px'}}>veces</label>
			</td>
		</tr>

		<tr><td className="e-textlabel">Descripcion</td><td colSpan={4}>
		<textarea id="Description" className="e-field e-input" name="Description" rows={3} cols={50} 
		style={{ width: '100%', height: '60px !important', resize: 'vertical' }}></textarea>
		</td></tr></tbody></table> : <div></div>);
    }

	handleInputChanges(event){
		if(event.element){
			switch(event.element.id){
				case "frequency":
					this.frequency = event.value;
					if(event.value === 'NONE'){
						this.repeatOption2.current.style.display = 'none';
						this.repeatOption1.current.style.display = 'none';
					}else{
						this.repeatOption2.current.style.display = '';
						this.repeatOption1.current.style.display = '';

						this.repeatTimes.current.disabled = this.radioRepeatTimes.current.checked?false:true;
						this.repeatDate.current.enabled = this.radioRepeatUntil.current.checked?true:false;
					}
				break;
				case "repeat_until_date":
					this.repeatUntilDate = event.value;
					this.repeatTimesValue = false;
				break;
				case "status":
					this.statusSelected = event.value;
				break;
				default:

			}
		}else if( event.target.name === 'repeat_type' ){
			if(event.target.id === 'repeat_until'){
				this.repeatTimes.current.disabled = true;
				this.repeatDate.current.enabled = true;
			}else{ //repeat_times
				this.repeatTimes.current.disabled = false;
				this.repeatDate.current.enabled = false;
			}
		}else if(event.target.name === 'times'){
			this.repeatTimesValue = parseInt(event.target.value);
			this.repeatUntilDate = false;
		}
	}

    dateToStringDate(date){
		const today = new Date();
		const hoursFromTimezoneOffset = (today.getTimezoneOffset()*-1) / 60;
		
		date.setHours(date.getHours()+hoursFromTimezoneOffset);

		const dateString = date.getUTCFullYear() + "-" +
			("0" + (date.getUTCMonth()+1)).slice(-2) + "-" +
			("0" + date.getUTCDate()).slice(-2) + " " +
			("0" + date.getUTCHours()).slice(-2) + ":" +
			("0" + date.getUTCMinutes()).slice(-2) + ":" +
			("0" + date.getUTCSeconds()).slice(-2);

		return dateString;
    }

    onActionBegin(args){
		switch(args.requestType){
			case "eventCreate":
				//args.addedRecords
					this.createEvent(args);
				break;
			case "eventChange":
				//args.changedRecords
				if(args.data.occurrence){
					this.changeFromSerie(args);
				}else{
					this.changeEvent(args);
				}
				break;
			case "eventRemove":
				//Cuando se elimina algo de una serie, nos llega en ChangedRecords
				if(args.data[0].occurrence){
					this.deleteFromSerie(args.changedRecords[0]);
				}else{
					//Cuando se elimina una cita unica es deletedRecords
					this.removeEvent(args.deletedRecords.length>0?args.deletedRecords:args.changedRecords);
				}
				break;
			default:
				break;
		}
    }

	changeFromSerie(appointments){
		//Hay que crear excepcion para el dia y crear nuevo evento
		//this.deleteFromSerie(appointments.data.parent, appointments.data.occurrence);
		this.deleteFromSerie(appointments.changedRecords[0], appointments.data.occurrence);
	}

	deleteFromSerie(appointment, eventToCreate){
		const api = this.getApi();
		
		//let objToWork = JSON.parse(JSON.stringify(appointment));
		//let appointmentToUpdate = JSON.parse(JSON.stringify(this.transformAppointmentToSchedule(appointment)));
		let appointmentToUpdate = {...this.transformAppointmentToSchedule(appointment)};
		
		let objToWork = {...appointmentToUpdate};

		appointmentToUpdate.exception = this.stringDateToExceptionDate(this.dateToStringDate(new Date(objToWork.start_date)));

		if(eventToCreate){
			this.setState(prevState => {
				return {
					...prevState,
						appointmentToUpdate,
						aditionalEventToCreate: eventToCreate
				}
			},api.updateSchedule(appointmentToUpdate, this.modifyAppointmentCallback));
		}else{
			this.setState(prevState => {
				return {
					...prevState,
						appointmentToUpdate
				}
			},api.updateSchedule(appointmentToUpdate, this.modifyAppointmentCallback));
		}
	}

	stringDateToExceptionDate(stringDate){
		let exceptionDate = stringDate.replace(/\s/, 'T');
		exceptionDate = exceptionDate.replace(/[:-]/g, '')+"Z";
		
		return exceptionDate;
	}

	createEvent(args){
		const api = this.getApi();
		let apiParams = {};
		let newRecord;
		if(this.state.aditionalEventToCreate === args){
			newRecord = {...this.state.aditionalEventToCreate};
			let state1 = {...this.state};
			delete state1.aditionalEventToCreate;
			this.setState(state1);
		}else{
			newRecord = args.addedRecords[0];
		}
		let newClone = JSON.parse(JSON.stringify(newRecord));
		newClone.client = this.clientInputValue?this.clientInputValue:newRecord.client;

		apiParams = {
			title: newRecord.Subject?newRecord.Subject:'',
			start_date: typeof newRecord.StartTime === 'object'?this.dateToStringDate(newRecord.StartTime):
			this.dateToStringDate(new Date(newRecord.StartTime)),
			end_date: typeof newRecord.EndTime === 'object'?this.dateToStringDate(newRecord.EndTime):
			this.dateToStringDate(new Date(newRecord.EndTime)),
			//status: newRecord.status?newRecord.status:1,
			//assigned_user: "", //Solo lo metemos si somos superusuario y podemos elegir a quien va a ir la cita
			description: newRecord.Description?newRecord.Description:''
		};

		apiParams.status = this.statusSelected?this.statusSelected:1;
		apiParams.frequency = this.frequency?this.frequency:'NONE';
		apiParams.repeat_condition = this.frequency?
			this.repeatTimesValue?
				this.repeatTimesValue:this.repeatUntilDate
			:false;
		this.frequency = false;

		if(this.clientInputValue._id) apiParams.client = this.clientInputValue._id;
		this.clientInputValue = {};

		this.setState(prevState => {
			return {
				...prevState,
					appointmentToCreate: newClone
			}
		},api.newSchedule(apiParams, this.apiNewCallback));
	}

	changeEvent(args){
		const api = this.getApi();
		let modifiedRecord = this.transformAppointmentToSchedule(args.changedRecords[0]);

		const modifiedClone = JSON.parse(JSON.stringify(modifiedRecord));
		modifiedClone.client = this.deletedClient?undefined:this.clientInputValue && this.clientInputValue._id?this.clientInputValue:modifiedRecord.client;

		let cloneForApi = JSON.parse(JSON.stringify(modifiedRecord));

		if(typeof modifiedClone.client === 'string' || modifiedClone.client === null){
				const fullAppointment = this.state.appointments.filter(ap => {
				return ap.client == modifiedClone.client
			});

			if(fullAppointment[0]){
				modifiedClone.client = fullAppointment[0].completeClient;
			}

			cloneForApi.client = modifiedClone.client;
		}else{
			cloneForApi.client = this.deletedClient?undefined:modifiedClone.client._id?modifiedClone.client._id:undefined;
		}

		this.clientInputValue = {};

		this.setState(prevState => {
			return {
				...prevState,
					appointmentToUpdate: modifiedClone
			}
		},api.updateSchedule(cloneForApi, this.modifyAppointmentCallback));
	}

	removeEvent(records){
		const api = this.getApi();
		let recordToRemove = records[0];
		let removedClone = JSON.parse(JSON.stringify(recordToRemove));
		removedClone.client = this.clientInputValue._id?this.clientInputValue._id:recordToRemove.client;
		recordToRemove.client = this.clientInputValue._id?this.clientInputValue:recordToRemove.client;
		this.clientInputValue = {};

		this.setState(prevState => {
			return {
				...prevState,
					appointmentToDelete: removedClone
			}
		},api.deleteSchedule(recordToRemove.id, this.apiDeleteCallback));
	}

    modifyAppointmentCallback(response){
		let apps = this.state.appointments.map(ap => {
			return ap.id === this.state.appointmentToUpdate._id?this.transformSchedulesToAppointments(this.state.appointmentToUpdate,true):ap
		});
		this.setState(prevState => {
			return {
				...prevState,
				appointments: apps
			}
		},this.createNewEvent);
    }

	createNewEvent(){
		if(!this.state.aditionalEventToCreate) return;
		this.createEvent(this.state.aditionalEventToCreate);
	}

    apiNewCallback(response){
	//if(response.status === 'OK'){
		
		let appointment = JSON.parse(JSON.stringify(response));
		appointment.id = response._id;
		appointment._id = response._id;
		appointment.assigned_user = response.assigned_user;
		appointment.status = response.status;

		let newAppointments = this.state.appointments;
		newAppointments.push(this.transformSchedulesToAppointments(appointment, true));

		//El plugin Scheduler crea un evento por su cuenta, lo eliminamos para meter el nuestro llegado del backend
		newAppointments = newAppointments.filter(app => {
			return app.id !== undefined
		});

		this.setState(prevState => {
		    return {
			...prevState,
			appointments: newAppointments
		    }
		}, this.refresh);
	//}
    }
    
    apiDeleteCallback(response){
    	if(response.status === 'OK'){
			this.setState(prevState => {
					return {
						...prevState,
						appointments: this.deleteAppointment(this.state.appointments)
					}
			}, this.refresh);
		}
    }

    deleteAppointment(appointments){
		return appointments.filter(apn => {
			return apn.id !== this.state.appointmentToDelete.id
		});
    }

    render() {

    	return (
		<>
			<buttton className="btn btn-primary" onClick={this.verState} >Ver estado</buttton>
    		<ScheduleComponent editorTemplate={this.editorTemplate.bind(this)} timezone='Europe/Madrid' locale='es' timeFormat='HH:mm'
    			eventSettings={{ dataSource: this.state.appointments }} actionBegin={this.onActionBegin.bind(this)}
    			timeScale={{ enable: true, interval: 60, slotCount: 4 }} 
				startHour='07:00' endHour='22:00'>
    		    <Inject services={[Day, Week, Month]}/>
    		    <ViewsDirective>
    			<ViewDirective option='Day' />
    			<ViewDirective option='Week' firstDayOfWeek='1' />
    			<ViewDirective option='Month' firstDayOfWeek='1' />
    		    </ViewsDirective>
    		</ScheduleComponent>
		<ClientSelector ref={this.clientSel} onClientSelected={this.clientSelectedCallback} />
		</>
        )
    }
}

export default Scheduler
